import { useEffect, useState } from "react";
import { Copy, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { tr } from "../lib/i18n";
import { copyText } from "./ShareCarDialog";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export default function MarketplaceDialog({ vehicleId, stock, open, onClose }) {
  const [data, setData] = useState(null);
  const [zipping, setZipping] = useState(false);
  useEffect(() => {
    if (!open) return;
    setData(null);
    api.get(`/vehicles/${vehicleId}/marketplace`).then(({ data: d }) => setData(d)).catch((e) => toast.error(formatApiError(e)));
  }, [open, vehicleId]);
  const download = async () => {
    setZipping(true);
    try {
      const { data: blob } = await api.get(`/vehicles/${vehicleId}/photos.zip`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = `${stock || "car"}-photos.zip`; a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 5000);
    } catch (e) { toast.error(formatApiError(e)); } finally { setZipping(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="marketplace-dialog">
        <DialogHeader className="pe-8"><DialogTitle>{tr("share.mp_title")}</DialogTitle><DialogDescription>{tr("share.mp_help")}</DialogDescription></DialogHeader>
        {!data ? <Loader2 className="animate-spin" /> : (
          <div className="space-y-3">
            {data.fields.map((f) => (
              <div key={f.key} className="border border-[var(--line)] rounded-lg p-3" data-testid={`mp-field-${f.key}`}>
                <div className="flex items-center justify-between gap-2 mb-1">
                  <span className="eyebrow">{tr(`share.f_${f.key /* i18n-keys: title_en,title_ar,price,mileage,year,colour,transmission,fuel,description_en,description_ar */}`)}</span>
                  <button className="btn-secondary !py-1 !px-2 text-xs" onClick={() => copyText(f.value)} data-testid={`mp-copy-${f.key}`}><Copy size={12} /> {tr("share.copy_short")}</button>
                </div>
                <div dir={f.key.endsWith("_ar") ? "rtl" : "auto"} className="text-sm whitespace-pre-wrap" data-testid={`mp-value-${f.key}`}>{f.value}</div>
              </div>
            ))}
            <button className="btn-primary" disabled={!data.photo_count || zipping} onClick={download} data-testid="mp-download-photos">
              {zipping ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} {tr("share.download_photos", { p0: data.photo_count })}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
